import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ShieldCheck, Clock, ArrowRight, X } from "lucide-react";
import { http } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ loading: true, ok: false, message: "" });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, ok: false, message: "Missing verification token." });
      return;
    }
    http.post("/auth/verify-email", { token })
      .then(({ data }) => {
        setState({ loading: false, ok: true, message: data?.message || "Email confirmed." });
      })
      .catch((err) => {
        setState({
          loading: false,
          ok: false,
          message: err?.response?.data?.detail || "Verification link is invalid or expired.",
        });
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
      <div className="bento-card max-w-lg w-full p-8 md:p-10" data-testid="verify-email-card">
        {state.loading ? (
          <div className="text-center text-white/60 text-sm">Confirming your email…</div>
        ) : state.ok ? (
          <>
            <div className="inline-flex items-center gap-1.5 px-2 py-1 rounded border border-electric/30 bg-electric/10 mb-4">
              <ShieldCheck size={11} className="text-electric" />
              <span className="text-[10px] font-display font-bold tracking-widest uppercase text-electric">Email Confirmed</span>
            </div>
            <h1 className="font-display text-3xl md:text-4xl font-black uppercase tracking-tight leading-tight">
              Thanks — now we verify <span className="text-electric">you.</span>
            </h1>
            <div className="mt-5 flex items-start gap-2 text-amber-300 text-sm">
              <Clock size={14} className="mt-0.5 flex-shrink-0" />
              <p>Identity review can take up to <strong>24 hours</strong>.</p>
            </div>
            <p className="text-sm text-white/70 mt-4 leading-relaxed">
              {state.message}
            </p>
            <p className="text-xs text-white/50 mt-4 leading-relaxed">
              We hand-check every recruiter account against published school directories to protect our athletes and their families.
              You'll get an email the moment your account is activated.
            </p>
            <Link to="/login" className="btn-primary w-full justify-center mt-6 text-xs" data-testid="verify-back-login">
              Back to Log in <ArrowRight size={12} />
            </Link>
          </>
        ) : (
          <>
            <div className="inline-flex items-center gap-1.5 px-2 py-1 rounded border border-rose-400/30 bg-rose-400/10 mb-4">
              <X size={11} className="text-rose-400" />
              <span className="text-[10px] font-display font-bold tracking-widest uppercase text-rose-400">Verification Failed</span>
            </div>
            <h1 className="font-display text-3xl font-black uppercase tracking-tight">
              Couldn't confirm that link.
            </h1>
            <p className="text-sm text-white/70 mt-4">{state.message}</p>
            <Link to="/login" className="btn-ghost w-full justify-center mt-6 text-xs" data-testid="verify-back-login">
              Back to Log in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
